/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetMarketsStructuresStructureId200Ok
 */
export interface GetMarketsStructuresStructureId200Ok {
    /**
     * duration integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    duration: number;
    /**
     * is_buy_order boolean
     * @type {boolean}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    isBuyOrder: boolean;
    /**
     * issued string
     * @type {Date}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    issued: Date;
    /**
     * location_id integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    locationId: number;
    /**
     * min_volume integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    minVolume: number;
    /**
     * order_id integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    orderId: number;
    /**
     * price number
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    price: number;
    /**
     * range string
     * @type {string}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    range: GetMarketsStructuresStructureId200OkRangeEnum;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    typeId: number;
    /**
     * volume_remain integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    volumeRemain: number;
    /**
     * volume_total integer
     * @type {number}
     * @memberof GetMarketsStructuresStructureId200Ok
     */
    volumeTotal: number;
}


/**
 * @export
 */
export const GetMarketsStructuresStructureId200OkRangeEnum = {
    Station: 'station',
    Region: 'region',
    Solarsystem: 'solarsystem',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    _10: '10',
    _20: '20',
    _30: '30',
    _40: '40'
} as const;
export type GetMarketsStructuresStructureId200OkRangeEnum = typeof GetMarketsStructuresStructureId200OkRangeEnum[keyof typeof GetMarketsStructuresStructureId200OkRangeEnum];


/**
 * Check if a given object implements the GetMarketsStructuresStructureId200Ok interface.
 */
export function instanceOfGetMarketsStructuresStructureId200Ok(value: object): value is GetMarketsStructuresStructureId200Ok {
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('isBuyOrder' in value) || value['isBuyOrder'] === undefined) return false;
    if (!('issued' in value) || value['issued'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('minVolume' in value) || value['minVolume'] === undefined) return false;
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('range' in value) || value['range'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    if (!('volumeRemain' in value) || value['volumeRemain'] === undefined) return false;
    if (!('volumeTotal' in value) || value['volumeTotal'] === undefined) return false;
    return true;
}

export function GetMarketsStructuresStructureId200OkFromJSON(json: any): GetMarketsStructuresStructureId200Ok {
    return GetMarketsStructuresStructureId200OkFromJSONTyped(json, false);
}

export function GetMarketsStructuresStructureId200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsStructuresStructureId200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'],
        'isBuyOrder': json['is_buy_order'],
        'issued': (new Date(json['issued'])),
        'locationId': json['location_id'],
        'minVolume': json['min_volume'],
        'orderId': json['order_id'],
        'price': json['price'],
        'range': json['range'],
        'typeId': json['type_id'],
        'volumeRemain': json['volume_remain'],
        'volumeTotal': json['volume_total'],
    };
}

export function GetMarketsStructuresStructureId200OkToJSON(json: any): GetMarketsStructuresStructureId200Ok {
    return GetMarketsStructuresStructureId200OkToJSONTyped(json, false);
}

export function GetMarketsStructuresStructureId200OkToJSONTyped(value?: GetMarketsStructuresStructureId200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duration': value['duration'],
        'is_buy_order': value['isBuyOrder'],
        'issued': ((value['issued']).toISOString()),
        'location_id': value['locationId'],
        'min_volume': value['minVolume'],
        'order_id': value['orderId'],
        'price': value['price'],
        'range': value['range'],
        'type_id': value['typeId'],
        'volume_remain': value['volumeRemain'],
        'volume_total': value['volumeTotal'],
    };
}

